module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><h5 class="icon-header">'+
((__t=( i18n.tc("Recipients", "Edit Recipient") ))==null?'':__t)+
'</h5><div><label for="recipient-name">'+
((__t=( i18n.tc("Recipients", "Name:") ))==null?'':__t)+
'</label> <input maxlength="50" id="recipient-name" value="'+
((__t=( name ))==null?'':__t)+
'" type="text" data-input="recipient-name" required></div></fieldset><fieldset class="button-wrap"><button type="submit" data-click="recipient-submit" class="primary" disabled="disabled">'+
((__t=( i18n.tc("Recipients", "Save") ))==null?'':__t)+
'</button></fieldset><div data-container="recipients-add"><div class="email-container"><a class="pull-right icon icon-material icon-circle-plus" data-click="recipient-email-new"></a><h5 class="email-recipients-header">'+
((__t=( i18n.tc("Recipients", "E-mail") ))==null?'':__t)+
'</h5><div data-region="email-recipients"></div><div data-region="newEmail"></div></div><div class="sms-container"><a class="pull-right icon icon-material icon-circle-plus" data-click="recipient-sms-new"></a><h5 class="sms-recipients-header">'+
((__t=( i18n.tc("Recipients", "SMS") ))==null?'':__t)+
'</h5><div data-region="sms-recipients"></div><div data-region="newSms"></div></div></div><fieldset class="button-wrap"><button class="primary" data-button="recipients-close">'+
((__t=( i18n.tc("Recipients", "Close") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
